var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4992 9.85533C10.5333 9.85533 11.3717 9.01699 11.3717 7.98284C11.3717 6.94869 10.5333 6.11035 9.4992 6.11035C8.46505 6.11035 7.62671 6.94869 7.62671 7.98284C7.62671 9.01699 8.46505 9.85533 9.4992 9.85533Z",
    stroke: "#CB9C2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.46991 6.89502C5.65222 1.69766 13.3522 1.70366 14.5285 6.90102C15.2187 9.94981 13.3222 12.5305 11.6598 14.1269C10.4535 15.2912 8.54497 15.2912 7.33266 14.1269C5.67622 12.5305 3.77973 9.94381 4.46991 6.89502Z",
    stroke: "#CB9C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.efe680998f1bdfd14b4066789a8e31e2.svg";
export { ForwardRef as ReactComponent };